import './App.css';
import LandingPage from './LandingPage';

function App() {
  return (
    <div className="App">
      <LandingPage></LandingPage>
    </div>
  );
}

export default App;
